import Store from "@/services/store";
import Router from "@/services/router";
import advancedFormsModule from "@/modules/toolbox/tools/advanced-forms/module";

export default {
  init({ dispatch }) {
    console.info("Toolbox module initialized.");
    dispatch("initToolboxModule", advancedFormsModule);
  },
  initModule({ dispatch }, module) {
    Store.registerModule(module.name, module.store);
    Router.addRoutes(module.routes);
    dispatch(module.name + "/init", null, { root: true });
  },
  initToolboxModule({ dispatch }, module) {
    Store.registerModule(["toolbox", module.name], module.store);
    Router.addRoutes(module.routes);
    dispatch("toolbox/" + module.name + "/init", null, { root: true });
  }
};
